var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticStyle:{"width":"100%","margin":"0"}},[_vm._m(0),_c('p',[_vm._v(_vm._s(_vm.address)+"\n    ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('ul',[_c('li',[_c('p',[_vm._v(" アクロニムテクノロジ―")])])])
}]

export { render, staticRenderFns }